import { FC } from 'react'

import { styled } from 'styled-components'

import { FallbackProps } from 'core/components/lib/ErrorBoundary/defaultErrorBoundaries'
import ErrorRecoveryActions from 'core/components/lib/ErrorBoundary/ErrorRecoveryActions'

const ErrorBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
`

const MaintenanceFallback: FC<FallbackProps> = ({ className, reset }) => (
  <ErrorBox className={className}>
    <span>This site is briefly undergoing maintenance. We appreciate your patience.</span>
    <ErrorRecoveryActions onRetry={reset} />
  </ErrorBox>
)

export default MaintenanceFallback
